import moment from 'moment'
import { EventPages } from 'Event/redux/actions/EventNavigation'
import { buildCalendarSearch } from 'Event/scenes/events/hooks/calendarUrl'
import { viewTypes } from 'Event/scenes/events/viewTypes'

export const getEventsPageFallbackUrl = (eventsPage: EventPages, orgTimezone: string): string => {
  if (eventsPage === EventPages.Calendar) {
    const today = moment().tz(orgTimezone).startOf('month')

    return `/events/${viewTypes.MONTH}?${buildCalendarSearch(today)}`
  }

  return '/list-of-events'
}
